import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { Device } from "src/app/model/device";
import { AppState } from "src/app/store/app.reducer";
import { selectDeviceEdited, selectDeviceEditing } from "src/app/store/device/device.selector";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { StandardPageLayout, StandardNewValidator } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";

@Component({
	templateUrl: './edit-device.dialog.component.html',
})

export class EditDeviceDialogComponent implements OnInit, OnDestroy {
	editDeviceForm: FormGroup;

	device: Device;
	deviceEditing$: Observable<boolean | undefined>;

	deviceEdited$: Observable<boolean | undefined>;
	deviceEditedSub: Subscription;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.device !== undefined) {
			this.device = config.data.device;
		}

		this.initSelectors();
	}

	initSelectors(): void {
		this.deviceEdited$ = this.store.select(selectDeviceEdited);
		this.deviceEditing$ = this.store.select(selectDeviceEditing);
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.deviceEditedSub?.unsubscribe();
	}

	buildForm(): void { 
		this.editDeviceForm = new FormGroup({
			'name': new FormControl(this.device.Name, Validators.required),
			'description': new FormControl(this.device.Description, Validators.required),
		});
	}

	subscribeAll(): void { 
		this.deviceEditedSub = this.deviceEdited$
			.pipe(filter(result => !!result))
			.subscribe(() => this.dialogRef.close('success')
		);
	}

	get f(): any {
		return this.editDeviceForm.controls;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.editDeviceForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.editDeviceForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void { 
		const device: Device = {
			...this.device,
			Name: this.f.name.value,
			Description: this.f.description.value,
	  };
	  this.store.dispatch(DeviceActions.editDevice({ device }));
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth,'w-30rem');
	}

	newShowErrors(type: EditDeviceDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type,classType,this.screenWidth);
	}

	showErrorRequiredMessage(type: EditDeviceDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

}